import React, {Component} from "react"
import {connect} from "react-redux"
import PropTypes from "prop-types"
import DetailsRefundTable from "./detailsRefundTable"
import {
    getCheckbooksOfRefund,
    getBackEndField,
} from "../../shared-components/actions/entities/checkbooks/checkbooksActions"
import {Entity, EntityInfo} from "../../shared-components/constants/entities"
import {isFetching} from "../../store/selectors/requests/requestsSelectors"
import {getIds} from "../../store/selectors/entities/entitiesSelectors"
import {getTotalResults} from "../../store/selectors/temporaries/paginationSelectors"
import {getRefundNumber} from "../../store/selectors/entities/detailRefundSelectors"
import {addNotification} from "../../shared-components/actions/notifications/notificationsActions"
import {
    updatePagination,
    goToPage,
    updateMaxPages,
} from "../../shared-components/actions/temporaries/pagination/paginationActions"
import {fillData, clear} from "../../shared-components/actions/temporaries/table/tableAction"
import {v4 as uuidv4} from "uuid"
import {clearRefundDetails} from "../../actions/temporaries/detailsRefund/detailsRefundActions"

class DetailsRefundTableContainer extends Component {
    static propTypes = {
        detailsRefundId: PropTypes.number.isRequired,
        detailsRefundNumber: PropTypes.number,
    }

    constructor() {
        super()

        this.state = {
            paginationComponentName: "detailsRefundTablePagination",
            sortedDirection: "DESC",
            sortedField: getBackEndField("id"),
            tableName: "detailsRefundTable",
        }
    }

    componentWillUnmount() {
        this.props.clearRefundDetails()
    }

    componentDidMount() {
        this.changePage()
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.detailsRefundId !== nextProps.detailsRefundId) {
            this.changePage(0, nextProps.detailsRefundId)
        }
    }

    /**
     * Change table page
     */
    changePage = (pageNumber = 0, detailsRefundId) => {
        this.props
            .getCheckbooksOfRefund(
                !detailsRefundId ? this.props.detailsRefundId : detailsRefundId,
                pageNumber,
                this.state.sortedField,
                this.state.sortedDirection,
                10,
            )
            .then(
                pagination => {
                    // fill the table
                    this.props.fillData(this.state.tableName, this.props.checkbooksIds)

                    // Update the pagination component
                    this.props.updatePagination(this.state.paginationComponentName, pagination)
                },
                () => {
                    this.props.addNotification({
                        id: uuidv4(),
                        type: "error",
                        header: "Erreur lors de la récupération du détail de la remise",
                        content: "Veuillez recharger la page",
                        autoDismiss: true,
                    })
                },
            )
    }

    /**
     * Get the refund number by it's ID in Database, to display it in component.
     * @param id
     */
    getRefundNumber = id => {
        return this.props.getRefundNumber(id)
    }

    /**
     * When a user sort a column from table
     * @param sortedField
     * @param sortDirection
     */
    sortColumn = (sortedField, sortDirection) => {
        this.setState(
            {
                sortedField: getBackEndField(sortedField),
                sortedDirection: sortDirection === "ascending" ? "ASC" : "DESC",
            },
            () => {
                // Update table
                this.changePage(0, this.props.detailsRefundId)

                // Go to first page
                this.props.goToPage(this.state.paginationComponentName, 1)
            },
        )
    }

    render() {
        const {detailsRefundId, checkbooksIds, isFetchingRetrieve, totalResults} = this.props

        return (
            <DetailsRefundTable
                changePage={this.changePage}
                checkbooksIds={checkbooksIds}
                clearRefundDetails={this.props.clearRefundDetails}
                detailsRefundId={detailsRefundId}
                detailsRefundNumber={this.props.detailsRefundNumber}
                getRefundNumber={this.getRefundNumber}
                isFetchingRetrieve={isFetchingRetrieve}
                sortColumnFunction={this.sortColumn}
                totalResults={totalResults(this.state.paginationComponentName)}
            />
        )
    }
}

const mapStateToProps = state => ({
    checkbooksIds: getIds(state, EntityInfo[Entity.CHECKBOOKS].name),
    getRefundNumber: id => getRefundNumber(state, id),
    isFetchingRetrieve: isFetching(state, EntityInfo[Entity.CHECKBOOKS].name),
    totalResults: componentName => getTotalResults(state, componentName),
})

const mapDispatchToProps = dispatch => ({
    addNotification: notification => dispatch(addNotification(notification)),
    clearData: tableName => dispatch(clear(tableName)),
    clearRefundDetails: () => dispatch(clearRefundDetails()),
    fillData: (tableName, checkbooksIds) => dispatch(fillData(tableName, checkbooksIds)),
    getCheckbooksOfRefund: (intervenantId, refundId, page, sortedField, sortedDirection, limit) =>
        dispatch(getCheckbooksOfRefund(intervenantId, refundId, page, sortedField, sortedDirection, limit)),
    goToPage: (componentName, page) => dispatch(goToPage(componentName, page)),
    updateMaxPages: (componentName, maxPages) => dispatch(updateMaxPages(componentName, maxPages)),
    updatePagination: (componentName, pagination) => dispatch(updatePagination(componentName, pagination)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailsRefundTableContainer)
